<mat-toolbar class="footer">
    <!-- espacio intermedio -->
    <span class="footer-space"></span>

    <span>-v3.0-</span>

    <!-- espacio intermedio -->
    <span class="footer-space"></span>
</mat-toolbar>